import { Link, useNavigate } from "react-router-dom";

import styles from "./TrainCard.module.scss";
import { ReactComponent as LeftArrow } from "@/assets/img/train-cards/left-arrow.svg";
import LockIcon from "@/assets/lock.png";
import { tg } from "@/constants/telegram";
import { cn } from "@/shared/utils";

type TrainCardProps = {
  index: number;
  title: string;
  image: string;
  describtion: string;
  duration: string;
  isLocked?: boolean;
  className?: string;
  style?: React.CSSProperties;
  trainingType?: "free" | "schedule";
  onDelete?: (e: React.MouseEvent) => void;
  isAdmin?: boolean;
  adminUserId?: number;
  editBasePath?: string;
};

export const TrainCard: React.FC<TrainCardProps> = ({
  index,
  title,
  image,
  isLocked,
  className,
  style,
  trainingType,
  onDelete,
  isAdmin,
  adminUserId,
  editBasePath,
}) => {
  const navigate = useNavigate();


  const handleCardClick = (e: React.MouseEvent) => {
    tg.HapticFeedback.impactOccurred("medium");
    
    if (isLocked) {
      e.preventDefault();
      e.stopPropagation();
      navigate("/subscription");
    }
  };

  // Для админа/тренера все тренировки открываются на редактирование, для обычных пользователей - workout-preview
  const linkPath = isAdmin
    ? editBasePath 
      ? `${editBasePath}/${adminUserId}/edit-training/${index}`
      : `/admin/chats/${adminUserId}/edit-training/${index}`
    : `/workout-preview/${index}`;

  return (
    <Link
      to={linkPath}
      className={cn(
        styles.root,
        className,
        {
          [styles.today]: index === 0,
          [styles.hasOrnament]: index === 3,
        },
        "relative"
      )}
      onClick={handleCardClick}
      style={style}
    >
      {isLocked && (
        <div
          className={
            "!absolute top-0 left-0 right-0 bottom-0 m-auto bg-[#000000c9] w-full h-full flex justify-center items-center !z-20"
          }
        >
          <img src={LockIcon} alt="lock" className="w-[40px] h-[40px]" />
        </div>
      )}
      {/* Кнопка удаления - показываем только если передан onDelete */}
      {onDelete && (
        <button
          onClick={onDelete}
          className={styles.deleteButton}
          title="Удалить тренировку"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
      {/* Кнопка Play - показываем только если тренировка не заблокирована, нет кнопки удаления и это не админ */}
      {!isLocked && image !== "none" && !onDelete && !isAdmin && (
        <div
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            zIndex: 25,
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#4CAF50",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.3)";
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            tg.HapticFeedback.impactOccurred("medium");
            const path = isAdmin
              ? editBasePath 
                ? `${editBasePath}/${adminUserId}/edit-training/${index}`
                : `/admin/chats/${adminUserId}/edit-training/${index}`
              : `/workout-preview/${index}`;
            navigate(path);
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            style={{
              marginLeft: "2px", // Смещение для визуального центрирования треугольника
            }}
          >
            <path
              d="M8.5 6 L8.5 18 L17.5 12 Z"
              fill="white"
              stroke="white"
              strokeWidth="0.8"
              strokeLinejoin="round"
              strokeLinecap="round"
              style={{
                filter: "drop-shadow(0 0 1px rgba(0,0,0,0.2))",
              }}
            />
          </svg>
        </div>
      )}
      <div className={styles.root__img}>
        {image !== "none" && (
          <img
            src={image}
            alt={`train-card-image-${index}`}
            className={styles.image}
          />
        )}
      </div>

      {title && title !== "" && (
        <div
          className={styles.root__title}
          style={{ minHeight: "23px", maxHeight: "23px" }}
        >
          {title}
        </div>
      )}

      {index === 0 && (
        <div className={styles.root__btn + " main-btn"}>
          <LeftArrow />
          <span>Попробовать</span>
        </div>
      )}
    </Link>
  );
};

